export default __webpack_public_path__ + "static/media/pintor.299d0d7c.png";